import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AttendingPhysicianStateIds, useGetIdsReferencesCountries } from '@toktokdoctech/tokapi-client'
import { PatientCreationProps } from './_props'
import CommonLoaderBackdrop from '../../Common/CommonLoaderBackdrop'
import PatientForm from './PatientForm'
import { defaultPatientFormContextValues, PatientFormContextProvider } from '../context/PatientFormContext'
import { displaySnackbar } from '../../../actions/main'
import { useAppDispatch } from '../../../store'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { patientPageErrors } from '../_errors'
import { useGetInsi } from './services/useGetInsi'
import { PatientErrorDisclaimer } from './PatientErrorDisclaimer'

export const PatientCreation = ({ isExternal }: PatientCreationProps) => {
    const navigate = useNavigate()
    const currentHcs = useCurrentHcs()
    const dispatch = useAppDispatch()

    const { insi, isLoading, error } = useGetInsi('PROVISIONAL')

    const { data: countries, isLoading: isLoadingCountries } = useGetIdsReferencesCountries({ search: 'France' })
    const countryFrance = countries?.find((country) => country.codeIso === 'FR')

    const initialData = {
        id: '',
        address: undefined,
        objectId: '',
        firstName: undefined,
        firstFirstName: undefined,
        lastName: undefined,
        birthName: undefined,
        birthDate: undefined,
        sex: undefined,
        room: undefined,
        insNum: undefined,
        insOid: undefined,
        countryBirth: countryFrance,
        birthCityLabel: undefined,
        patientIsSameAsInsured: true,
        hasLtDiseases: undefined,
        firstNameList: undefined,
        hasCss: undefined,
        attendingPhysician: { state: AttendingPhysicianStateIds.Unknown },
        insuredSsn: undefined,
        identityProof: undefined,
        insiIdentityAttributes: [],
        contactEmail: undefined,
        contactPhone: undefined,
        manualIdentityValidation: undefined,
        birthCity: {
            com: undefined,
            libelle: undefined,
        },
    }

    React.useEffect(() => {
        if (currentHcs.isSynchroServiceEnabled) {
            dispatch(displaySnackbar('error', patientPageErrors.patientCreationForbidden))
            navigate('/patients')
        }
    }, [currentHcs.isSynchroServiceEnabled, dispatch, navigate])

    if (error) return <PatientErrorDisclaimer />

    if (isLoading || isLoadingCountries)
        return <CommonLoaderBackdrop open label="Chargement des informations du patient..." />

    return (
        <PatientFormContextProvider
            initialValues={{
                isExternal,
                mode: 'CREATION',
                ins: {
                    ...defaultPatientFormContextValues.ins,
                    identityStatus: insi,
                },
                originalIdentityStatus: insi,
            }}
        >
            <PatientForm data={initialData} />
        </PatientFormContextProvider>
    )
}
